<div mdbModal #seleccionarVendedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Seleccionar vendedor
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <form [formGroup]='formData' (ngSubmit)="buscar(true)" novalidate>
                <div class="modal-body">

                    <div class="row">
                        <div class="col">
                            <div class="md-form">
                                <input value="" type="text" id="rut" class="form-control" placeholder="Rut" #rut
                                    formControlName="rut" formatRut />
                                <label for="rut">Rut</label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="md-form">
                                <input value="" type="text" id="codigo" class="form-control" placeholder="Código"
                                    #codigo formControlName="codigo" onlyNumbers />
                                <label for="codigo">Código</label>
                            </div>
                        </div>
                        <div class="col">
                            <button mdbBtn type="submit" color="info" mdbWavesEffect>
                                <mdb-icon fas icon="search"></mdb-icon>
                                Buscar
                            </button>
                        </div>
                    </div>

                    <table class="table table-striped table-hover table-sm align-middle" *ngIf="data">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Rut</th>
                                <th scope="col" class="text-center">Código</th>
                                <th scope="col" class="text-center">Nombre</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="loading">
                                <td colspan="100%" style="text-align: center">
                                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                                </td>
                            </tr>
                            <tr *ngIf="!loading && data?.length === 0">
                                <td colspan="100%" style="text-align: center">
                                    No se encontró información
                                </td>
                            </tr>
                            <tr *ngFor="let cliente of data">
                                <td>{{ cliente.rutFormato | rut }}</td>
                                <td>{{ cliente.codigo }}</td>
                                <td>{{ cliente.nombre }}</td>
                                <td>
                                    <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                                        (click)="selectData(cliente)">
                                        Seleccionar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                            *ngIf="dataAll?.length > 0"></app-pagination>
                    </table>
                </div>
            </form>
        </div>
    </div>
</div>
